import type { ReactElement } from 'react';
import { TaxreturnChartofaccounts } from './TaxreturnChartofaccounts';
import { TaxreturnDashboard } from './TaxreturnDashboard';
import { TaxreturnDatasecurity } from './TaxreturnDatasecurity';
import { TaxreturnSettings } from './TaxreturnSettings';
import { TaxreturnTaskCreatetrialbalance } from './TaxreturnTaskCreatetrialbalance';
import { TaxreturnTasks } from './TaxreturnTasks';

/** Ported screens of this slice, keyed by their Angular URL (see src/app/routeManifest.ts). */
export const screens: Record<string, ReactElement> = {
  '/home/taxreturns/dashboard': <TaxreturnDashboard />,
  '/home/taxreturns/tasks-accountingperiods': <TaxreturnSettings />,
  '/home/taxreturns/tasks-trialbalance': <TaxreturnTasks />,
  '/home/taxreturns/tasks-createtrialbalance': <TaxreturnTaskCreatetrialbalance />,
  '/home/taxreturns/settings-accoununts': <TaxreturnChartofaccounts />,
  '/home/taxreturns/settings-datasecurity': <TaxreturnDatasecurity />,
};
